<template>
<!--  <div class="header" :class="{'scroll':top>190}">-->
  <div class="header">
    <div class="h-box">
      <div class="top">
        <div class="logo-box" @click="jump('/',{navIndex:1})">
<!--          <img class="logo" src="@/assets/img/logo02mini.png">-->
          <div class="name-box">
<!--            <div class="name">{{ info.fullName }}</div>-->
<!--            <div class="en-name">{{ info.enName }}</div> -->
            <div class="name">四川凯策工程咨询有限公司</div>
            <div class="en-name">Sichuan Kaice Engineering Consulting Co., Ltd.</div>
          </div>
        </div>
        <!--        <div class="search-box" v-show="tabIndex === 4">-->
        <!--          <input v-model="keyword" type="text" placeholder="搜索">-->
        <!--          <button @click="search()"></button>-->
        <!--        </div>-->
      </div>
      <Nav></Nav>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/style1/Nav.vue';
import { INFO } from '@/util/const';

export default {
  name: 'Head',
  components: {
    Nav,
  },
  computed: {
    tabIndex() {
      return this.$store.state.tabIndex;
    },
  },
  props: ['top'],
  data() {
    return {
      keyword: '',
      info: INFO,
    };
  },
  methods: {
    search() {
      this.$store.state.search = 1;
      this.$store.state.keyword = this.keyword;
    },
  },
};
</script>

<style scoped>

</style>
